import React from 'react';
import { Card } from '../ui/Card';
import { StarIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 bg-cream" data-id="element-225">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-226">
        <Card variant="elevated" className="p-8 md:p-12 bg-gradient-to-br from-cream to-beige-light border-gold/20" data-id="element-227">
          <div className="flex justify-center gap-1 mb-6" data-id="element-228">
            {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-6 h-6 text-gold fill-gold" data-id="element-229" />)}
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-230">
            Lo que cambia en <span className="text-gold italic" data-id="element-231">7 días</span>
          </h2>

          <div className="prose prose-lg mx-auto text-center font-body text-taupe-light" data-id="element-232">
            <p className="leading-relaxed" data-id="element-233">
              En la primera semana, lo primero que notarás no es solo la
              balanza. <strong className="text-taupe" data-id="element-234">Es tu ropa.</strong>
            </p>
            <p className="leading-relaxed" data-id="element-235">
              La inflamación abdominal cede, tu cara se deshincha y, por primera
              vez en años, te despiertas antes de que suene la alarma con una{' '}
              <strong className="text-taupe" data-id="element-236">energía clara y calmada</strong>.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}